import React, { FC } from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import { CatalogueRoute } from './CatalogueRoute'
import { Box } from '@chakra-ui/core'
import { createBrowserHistory } from 'history'
import { isMobileOnly } from 'react-device-detect'

const history = createBrowserHistory()

export const Routes: FC = () => {
  return (
    <Box
      width={['100%', '425px']}
      height={['100%', '720px']}
      overflowY={isMobileOnly ? 'unset' : 'auto'}
      position="relative"
      alignSelf="center"
      margin="auto"
      shadow={['unset', 'rgba(194, 194, 194, 0.75) 3px 9px 17px 1px;']}
      display="flex"
    >
      <Router history={history}>
        <Switch>
          <Route path="/:customer/:order">
            <CatalogueRoute />
          </Route>
        </Switch>
      </Router>
    </Box>
  )
}
